import api from './request';

// 定义接口返回的数据类型
export interface ChildQuestion {
  id: number;
  questionName: string;
  pid: number;
  num: number | null;
  childQuestionName?: string;
  difyParam?: string;
}

export interface Question {
  id: number;
  questionName: string;
  pid: number;
  num: number;
  childQuestions: ChildQuestion[];
}

export interface Industry {
  id: string;
  industryName: string;
}

export interface Role {
  id: number;
  roleName: string;
}

export interface BaseDataResponse {
  code: number;
  message: string;
  data: {
    industryList: Industry[];
    questionList: Question[];
    roleList: Role[];
  };
}

// 获取基础数据的接口
export function reqBaseData() {
  return api.get<BaseDataResponse>('/proxy/service-sem/sem/hangye/data/all');
}
export function saveData(params:any) {
  return api.post<BaseDataResponse>('/proxy/service-sem/sem/customerQuestion', params);
}
export function submitData(params:any) {
  return api.post<BaseDataResponse>('/proxy/service-sem/sem/lead/submitCode', params);
}
export function lingxiSubmitData(params:any) {
  return api.post<BaseDataResponse>('/proxy/service-sem/sem/lead/lingxiSubmitCode', params);
}
export function saveLog(params:any) {
  return api.post<BaseDataResponse>('/proxy/service-sem/sem/customerSolutionLog', params);
}
